import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-folder",
  "use": "icon-si-glyph-folder-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-folder\" id=\"icon-si-glyph-folder\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>941</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 2.000000)\" fill=\"#434343\">\n            <path d=\"M7.35,3 L5.788,0.042 L2.021,0.042 L2.021,1.063 L0.023,1.063 L0.023,10.976 L1.043,10.976 L1.045,11.976 L15.947,11.976 L15.968,3 L7.35,3 L7.35,3 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M13.964,1.982 L8.354,1.982 L8.024,1.042 L13.964,1.042 L13.964,1.982 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-folder.svg
// module id = qGB+
// module chunks = 62